<template>

<div>

    <modal-form :active-card="activeCard"
           :customer="customer"
           :affiliates="affiliates"
           :products="products"
           :preselectAddress="preselectAddress"
           v-on:saveCard="saveCard">
    </modal-form>

    <modal-punch :active-card="activeCard"
           :customer="customer"
           :inactive-from-period="inactiveFromPeriod">
    </modal-punch>

    <modal-codes :active-card="activeCard"
           :customer="customer">
    </modal-codes>

    <div class="panel panel-clinic">

        <div class="panel-heading" href="#customer_cards" data-toggle="collapse">

            <div class="arrow-down"></div>

            <h2 class="panel-title">Klippkort</h2>

        </div>

        <div id="customer_cards" class="panel-collapse collapse">

            <div class="panel-body">

                <a class="btn btn-default btn-sm pull-right" data-target="#modal" data-toggle="modal" v-on:click="openModal('new')">
                	<i class="fa fa-file" style="margin-right: 4px;" aria-hidden="true"></i> Nytt klippkort
                </a>

                <h3>Klippkort</h3>

                <div class="panel panel-default">

                    <div class="panel-heading">
                        <div class="row">
                            <div class="col-lg-4 col-md-8 hidden-sm hidden-xs">Skapat</div>
                            <div class="col-lg-4 hidden-md hidden-sm hidden-xs">Giltigt till</div>
                            <div class="col-lg-4 col-md-8 col-xs-34">Produkt</div>
                            <div class="col-lg-4 col-md-6 hidden-sm hidden-xs">Pris</div>
                            <div class="col-lg-7 hidden-md hidden-sm hidden-xs">Försäljningskanal</div>
                            <div class="col-lg-4 hidden-md hidden-sm hidden-xs" title="Rabattkod från webbshop">Rabatt</div>
                            <div class="col-lg-3 hidden-md hidden-sm hidden-xs">Konto</div>
                            <div class="col-lg-6 col-md-10 hidden-sm hidden-xs">Ordernummer</div>
                            <div class="col-lg-3 col-md-4 hidden-sm hidden-xs">Klipp</div>
                            <div class="col-lg-4 col-md-4 hidden-sm hidden-xs">Nyttjade</div>
                            <div class="col-lg-3 col-md-4 hidden-sm hidden-xs">Kvar</div>
                        </div>
                    </div>

                    <div class="list-group">

                        <li class="list-group-item" v-for="card in cards">

                    	<div class="row">

                    		<div class="col-lg-4 col-md-8 hidden-sm hidden-xs">{{ card.created_at.substring(0, 10) }}</div>
                    		<div class="col-lg-4 hidden-md hidden-sm hidden-xs">{{ card.valid_to.substring(0, 10) }}</div>
                			<div class="col-lg-4 col-md-8 col-xs-34">{{ card.product.name }}<span v-if="card.is_manual == 1" style="font-weight:bold;"> (M)</span></div>
                			<div class="col-lg-4 col-md-6 hidden-sm hidden-xs">{{ card.price }} kr</div>
                            <div class="col-lg-7 hidden-md hidden-sm hidden-xs">{{ card.affiliate.name }}</div>
                            <div class="col-lg-4 hidden-md hidden-sm hidden-xs">{{ card.discount_code }}</div>
                			<div class="col-lg-3 hidden-md hidden-sm hidden-xs">{{ card.account.name }}</div>
                			<div class="col-lg-6 col-md-10 hidden-sm hidden-xs break-word"><span v-if="card.is_gift == 1" class="list-gift-card">P<div class="list-gift-card-popup"><b>Presentkort</b><br>Levereras: {{ card.hidden_to }}<br>Hälsning:<br>{{ card.gift_greeting }}</div></span> {{ card.order_number }} </div>
                            <div class="col-lg-3 col-md-4 hidden-sm hidden-xs">{{ card.punches_total }}</div>
                            <div class="col-lg-4 col-md-4 hidden-sm hidden-xs">{{ card.punches_used }}</div>
                            <div class="col-lg-3 col-md-4 hidden-sm hidden-xs">{{ card.punchesLeft }}</div>

                			<div class="col-lg-4 col-md-4 col-xs-16">
                                <div class="btn-group">
                                    <button type="button" class="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Hantera <span class="caret"></span>
                                    </button>
                                    <ul class="dropdown-menu">

                                        <li v-if="card.is_manual == 0">
                                            <a data-target="#modal_punch" data-toggle="modal" v-on:click="openModal(card)">Ta ett klipp</a>
                                        </li>

                                        <li v-if="card.is_manual == 1">
                                            <a data-target="#modal_codes" data-toggle="modal" v-on:click="openModal(card)">Visa koder</a>
                                        </li>

                                        <li role="separator" class="divider"></li>

                                        <li><a v-on:click="changePunches(card, 'add')">Öka antal +1</a></li>
                                        <li><a v-on:click="changePunches(card, 'remove')">Minska antal -1</a></li>

                                        <li role="separator" class="divider"></li>
                                        <li><a data-target="#modal" data-toggle="modal" v-on:click="openModal(card)">Ändra</a></li>
                                        <li role="separator" class="divider"></li>
                                        <li>
                                            <a v-on:click="notify(card, 'sms')" v-if="customer.phone">
                                                Skicka SMS
                                            </a>
                                            <a v-else style="text-decoration: line-through">
                                                Skicka SMS
                                            </a>
                                        </li>
                                        <li>
                                            <a v-on:click="notify(card, 'mail')" v-if="customer.email">
                                                Skicka e-post
                                            </a>
                                            <a v-else style="text-decoration: line-through">
                                                Skicka e-post
                                            </a>
                                        </li>

                                        <li role="separator" class="divider" v-if="card.punches_used == 0"></li>
                                        <li><a v-on:click="remove(card)" v-if="card.punches_used == 0">Ta bort</a></li>

                                    </ul>
                                </div>

                            </div>

                        </div>

                        </li>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>

</template>

<script>

import modalForm from './card.modalForm.vue'
import modalPunch from './card.modalPunch.vue'
import modalCodes from './card.modalCodes.vue'

export default {

    components: {
        modalForm,
        modalPunch,
        modalCodes
    },

    props: {

        customer: {},
        affiliates: {},
        products: {},
        inactiveFromPeriod: {}

	    },
	    data: function () {
        return {
            activeCard: null,
            cards: this.currentCards,
            preselectAddress: null
        }
    },

    created: function () {
        const self = this

        bus.$on('refresh-data', function () {
            self.load()
        })

        self.load()
    },

	    methods: {

        load: function () {
            const self = this

            this.$http.post('/customers/getCards', { customer_id: self.customer.id }).then((response) => {
                console.log(response.body)

                self.cards = response.body.cards
                self.preselectAddress = response.body.preselectAddress

                bus.$emit('log-reload')
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        saveCard: function (card, mode) {
            console.log('create a card')
            console.log(card)

            const self = this

            console.log('run mode')
            console.log(mode)

            this.$http.post('/cards/create', { customer_id: self.customer.id, card: card, mode: mode }).then((response) => {
                console.log('save card response')

                console.log(response.body)

                // self.cards = response.body;

                self.load()

                $('#modal').modal('hide')

                if (mode == 'new') {
                    if (card.send_mail == true) {
                        bus.$emit('notify', 'Klippkort skapat och sms/mail skickat till kund.')
                    } else if (card.affiliate.send_sms_for_new_cards === 1) {
                        bus.$emit('notify', 'Klippkort skapat och sms skickat till kund.')
                    } else {
                        bus.$emit('notify', 'Klippkort skapat')
                    }
                }

                if (mode == 'update') {
                    bus.$emit('notify', 'Klippkortet uppdaterades.')
                }
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        openModal: function (card) {
            this.activeCard = card
        },

        changePunches: function (card, method) {
            console.log(card)

            if (method == 'add') {
                card.punches_total++

                bus.$emit('notify', 'Ökade klipp +1')
            } else {
                card.punches_total--

                bus.$emit('notify', 'Minskade klipp -1')
            }

            this.saveCard(card, 'update_punches')
        },

        remove: function (card) {
            const self = this

            console.log('notify')

            this.$http.post('/cards/remove', { card_id: card.id }).then((response) => {
                console.log(response.body)

                bus.$emit('notify', 'Kortet har tagits bort.')
                bus.$emit('log-reload')

                self.load()
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        notify: function (card, type) {
            console.log('notify')

            this.$http.post('/customers/notify', { card_id: card.id, type: type }).then((response) => {
                console.log(response.body)

                if (type == 'sms') {
                    bus.$emit('notify', 'Skickade sms till kund.')
                }
                if (type == 'mail') {
                    bus.$emit('notify', 'Skickade e-post till kund.')
                }

                bus.$emit('log-reload')
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        addressTitle: function (card) {
            if (card.address) {
                return card.address.title
                // return '<a href="/addresses/">'+card.address.title+'</a>';
            } else {
                return ''
            }
        }

	}

}
</script>
